export const CASES_TABS = {
  OPEN: 0,
  CLOSED: 1,
};
